import script from "./GetUmlImage.vue?vue&type=script&lang=js"
export * from "./GetUmlImage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__